import React from "react";

const IdentificationModalInvalidInput = ({ wasValidated, error }) => {
  return wasValidated && error ? (
    <div className="alert alert-danger animated--fast-grow-in" role="alert">
      <span className="invalid-input-alert-circle mr-2" />
      <span className="invalid-input-alert-message">{error.message}</span>
    </div>
  ) : (
    <></>
  );
};

export default IdentificationModalInvalidInput;
